const refreshAccessToken = () => ({
  type: 'REFRESH_TOKEN_REQUEST',
});

const requestIdentity = () => ({
  type: 'IDENTITY_REQUEST',
});

const logout = () => ({
  type: 'LOGOUT_REQUEST'
});

export {
  refreshAccessToken,
  requestIdentity,
  logout
}
